import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { DELETE_DISH_TYPE_MUTATION } from '../graphql/mutations'
import { DELETE_DISH_TYPE } from '../redux/action-types'

const useDeleteDishTypeMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(store => store.dishTypes.dishTypes)

  const mutate = useCallback(
    async id => {
      await apolloService.mutate(
        DELETE_DISH_TYPE_MUTATION,
        {
          id,
        },
        dispatch,
        DELETE_DISH_TYPE,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useDeleteDishTypeMutation
